export default "__VITE_ASSET__uxAS9RlL__"